<sd-border-wrapper class="has-no-padding" [customClass]="!!isMobile$ ? 'brand--h4' : 'brand--h3'" [titleLevel]="!!isMobile$ ? 4 : 3">
  <div class="c__header">
    <sd-title [titleLevel]="!!isMobile$ ? 4 : 3" customClass="brand--h4 is-bold">
      {{ 'checkout.payment.choice' | translate }}
    </sd-title>
    <sd-title [titleLevel]="4" customClass="brand--h6">
      {{ 'checkout.payment.choiceReinsurance' | translate }}
    </sd-title>
  </div>
  <div class="c__wrapper">
    <sd-form radio-group
      class="c__btn-group"
      [disabled]="paymentMethods?.disabled"
      [formControlName]="paymentMethods?.nameField"
      [nameField]="paymentMethods?.nameField"
      [labelHidden]="paymentMethods?.labelHidden"
      [labelTitle]="paymentMethods?.labelTitle"
      [items]="paymentMethods?.methods"
      [required]="paymentMethods?.required"
      (valueChanged)="changePayment($event)"
      [applyDescriptionHidden]="true"
      [selectAdyen]="selectAdyenPayment"
    >
      <ng-content sd-payment-methods select="[sd-payment-methods]" />
    </sd-form>
  </div>
</sd-border-wrapper>
